module.exports = __webpack_public_path__ + "img/Jannes.35d93403.png";